import PickRequestPayload from "slotworks/model/gameplay/requests/pick-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contracts/contract";

export function LoadPickBonusCommand(pickIndex: number): Contract<void> {
    const payload = new PickRequestPayload();
    payload.pick = pickIndex;

    return CommsManager.request(payload);
}
